import type { Menu } from '@/types/menu'

interface MenuState {
  menusList: Menu[]
}

export const useMenuStore = defineStore('menus', {
  state: (): MenuState => ({
    menusList: [],
  }),
  getters: {
    menuState(state): Menu[] {
      return state.menusList
    },
    menus(state): Menu[] {
      return state.menusList
    },
  },
  actions: {
    setMenus(menus: Menu[]) {
      this.menusList = menus
    },
    getMenus(): Menu[] {
      return this.menusList
    },
    clearMenus() {
      this.menusList = []
    },
    getMenu(name: string): Menu | undefined {
      const list = [
        ...this.menusList.map((v) => {
          if (v.children) {
            return [v, ...v.children]
          } else {
            return v
          }
        }),
      ].flat()
      return list.find((v) => v.menuId === name)
    },
  },
})
